<template>
  <div>
    <header class="header">
      <div class="logo__container hvr-bob">
        <h1 class="logo">Conoce México</h1>
      </div>

      <div class="heading__text--container">
        <div class="heading__primary">
          <span class="heading__primary--main"
            >Viaja facil - Viaja diferente</span
          >
          <span class="heading__primary--sub">Viajes en grupo por México</span>
        </div>
        <a class="btn heading__button" href="#section-tours">Ver tours</a>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style></style>
